// Currency lookup utility
// Parses allcurrencies.json and importedcurrencies.json to create a mapping
// from currencyid to fullyqualifiedname

import allCurrencies from '../allcurrencies.json';
import importedCurrencies from '../importedcurrencies.json';

// Build the lookup table from both currency sources
const buildCurrencyLookup = () => {
  const lookup = {};
  
  // Process all currencies
  if (Array.isArray(allCurrencies)) {
    allCurrencies.forEach(item => {
      if (item?.currencydefinition?.currencyid && item?.currencydefinition?.fullyqualifiedname) {
        lookup[item.currencydefinition.currencyid] = item.currencydefinition.fullyqualifiedname;
      }
    });
  }
  
  // Process imported currencies
  if (Array.isArray(importedCurrencies)) {
    importedCurrencies.forEach(item => {
      if (item?.currencydefinition?.currencyid && item?.currencydefinition?.fullyqualifiedname) {
        lookup[item.currencydefinition.currencyid] = item.currencydefinition.fullyqualifiedname;
      }
    });
  }
  
  return lookup;
};

// The main lookup table
export const currencyIdToName = buildCurrencyLookup();

// Reverse lookup: name to id
export const currencyNameToId = Object.entries(currencyIdToName).reduce((acc, [id, name]) => {
  acc[name] = id;
  return acc;
}, {});

// Get a list of all known currency names (sorted)
export const getAllCurrencyNames = () => {
  return Object.values(currencyIdToName).sort((a, b) => a.localeCompare(b));
};

// Get a list of commonly used currencies for dropdowns (sorted alphabetically)
export const getCommonCurrencies = () => {
  const common = [
    'Bridge.vETH',
    'DAI.vETH',
    'ETH.vETH',
    'EURC.vETH',
    'MKR.vETH',
    'tBTC.vETH',
    'USDC.vETH',
    'USDT.vETH',
    'vETH',
    'VRSC',
  ];
  
  // Return only currencies that exist in our lookup, sorted alphabetically
  const existing = common.filter(name => currencyNameToId[name]);
  return existing.sort((a, b) => a.localeCompare(b));
};

// Helper to resolve a currency - returns the name if it's an ID, or the original if already a name
export const resolveCurrencyName = (currencyIdOrName) => {
  if (!currencyIdOrName) return '';
  
  // If it's a known ID, return the name
  if (currencyIdToName[currencyIdOrName]) {
    return currencyIdToName[currencyIdOrName];
  }
  
  // Otherwise return as-is (it might already be a name)
  return currencyIdOrName;
};

// Helper to resolve to ID - returns the ID if it's a name, or the original if already an ID
export const resolveCurrencyId = (currencyIdOrName) => {
  if (!currencyIdOrName) return '';
  
  // If it's a known name, return the ID
  if (currencyNameToId[currencyIdOrName]) {
    return currencyNameToId[currencyIdOrName];
  }
  
  // Otherwise return as-is (it might already be an ID)
  return currencyIdOrName;
};

const currencyLookup = {
  currencyIdToName,
  currencyNameToId,
  getAllCurrencyNames,
  getCommonCurrencies,
  resolveCurrencyName,
  resolveCurrencyId,
};

export default currencyLookup;
